import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SearchFacetParams } from '@search/const';
import { SearchSelectors, StateWithSearch } from '@search/data-access';
import { StateUtils, isNotUndefined } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SearchFacetService {
  constructor(private store: Store<StateWithSearch>) {}

  static createSearchQuery(facetParams: SearchFacetParams): string {
    const { activeFacets, categoryCode: allCategories, promoCode: allCampaigns, hasDiscount, sale } = facetParams;
    const activeFacetsQuery: string | undefined = activeFacets
      ?.map((facet) => `${encodeURIComponent(facet.code)}:${encodeURIComponent(facet.value.code)}`)
      .join(',');
    const queryParams: string = Object.entries({ allCategories, allCampaigns, hasDiscount, sale })
      .filter(([, value]) => Boolean(value))
      .map(([key, value]) => `${encodeURIComponent(key)}:${encodeURIComponent(value)}`)
      .join(',');

    const params = [queryParams, activeFacetsQuery].filter(Boolean);

    return params.join(',');
  }

  getFacetsTotalResultsState(): Observable<StateUtils.LoaderState<number>> {
    return this.store.select(SearchSelectors.getSearchFacetsTotalResultsState);
  }

  getFacetsTotalResults(): Observable<number> {
    return this.store.select(SearchSelectors.getSearchFacetsTotalResultsValue).pipe(filter<number>(isNotUndefined));
  }

  getFacetsTotalResultsLoading(): Observable<boolean> {
    return this.store.select(SearchSelectors.getSearchFacetsTotalResultsLoading);
  }

  getFacetsTotalResultsError(): Observable<boolean> {
    return this.store.select(SearchSelectors.getSearchFacetsTotalResultsError);
  }

  getFacetsTotalResultsSuccess(): Observable<boolean> {
    return this.store.select(SearchSelectors.getSearchFacetsTotalResultsSuccess);
  }
}
